<!-- Header using PrimeNG Toolbar - Fixed at top -->
<p-toolbar class="border-b flex-shrink-0">
  <ng-template pTemplate="start">
    <div class="flex items-center gap-3">
      <p-button
        icon="pi pi-bars"
        [rounded]="true"
        size="small"
        (onClick)="onMenuToggle()"
        [ariaLabel]="'home.toggleMenu' | translate"
      />
      <h1 class="text-xl font-semibold">{{ 'home.appName' | translate }}</h1>
    </div>
  </ng-template>
  
  <ng-template pTemplate="end">
    <div class="flex items-center gap-2">
      <!-- User menu will go here -->
    </div>
  </ng-template>
</p-toolbar>